import { useGoBack } from 'hooks/useGoBack';
import React, { useContext, useCallback } from 'react';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { AppContext, IAppContext } from 'appState/appContext';
import { EditApkContext, IEditApkContext } from 'modules/FirmwareAndApp/Apk/EditApk/editApkState/editApkContext';
import { editApk } from 'backend/apk';
import { convertUndefinedFields } from 'utils/helpers';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, refetchData, dataForSubmit, typeOfModalWindow } =
		useContext<IEditApkContext>(EditApkContext);
	const goBack = useGoBack();

	const handleRedirect = useCallback(() => {
		goBack('/app/tablet-app');
	}, [goBack]);

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await editApk(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleUpdateData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={handleRedirect}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleConfirm}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleUpdateData}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</ModalWrapper>
	);
};
